import React, { useRef } from 'react';
import { useEdituserappAppMutation, useGetuserappStatusQuery } from './complainUserAppSlice';

function ComplainUserAppEdit({ refOpen, editData, setEditData }) {
    const refCloseDriver = useRef(null);
    const [edituserappApp, { isLoading }] = useEdituserappAppMutation();

    const {
        data: userappStatus,
        isStatusListError,
        isStatusListLoading,
    } = useGetuserappStatusQuery();

    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleClick = async (e) => {
        e.preventDefault();
        try {
            const response = await edituserappApp({
                id: editData?.id,
                status: editData?.status,
                remark: editData?.remark
            });
            refCloseDriver.current.click();
            setEditData({ status: "", remark: "", id: "" });
            // console.log("response", response);
        } catch (e) {
            console.error("Error in cleaner edit", e);
        }
    };
    return (
        <>
            <button
                ref={refOpen}
                type="button"
                className="btn d-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#depOffCanvas1"
                aria-controls="depOffCanvas1"
            ></button>

            <div
                className="offcanvas offcanvas-end"
                data-bs-scroll="true"
                data-bs-backdrop="false"
                tabIndex="-1"
                id="depOffCanvas1"
                aria-labelledby="depOffCanvas1"
            >
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="offcanvas1Label">Edit User App</h5>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        ref={refCloseDriver}
                    ></button>
                </div>

                <div className="offcanvas-body">
                    <form className="row g-3">
                        <div className="col-md-12 text-left">
                            <label htmlFor="name" className="form-label font-weight-bold">Status</label>
                            <select
                                className="form-select mb-5"
                                aria-label="complain status"
                                id="status"
                                name="status"
                                value={editData?.status}
                                onChange={handleChange}
                            >
                                <option selected>--</option>
                                {!isStatusListLoading && !isStatusListError && userappStatus?.map(item => {
                                    return <option value={item}>{item}</option>
                                })}
                            </select>
                        </div>

                        <div className="col-md-12 text-left">
                            <label htmlFor="number" className="form-label font-weight-bold">Remark</label>
                            <input
                                type="text"
                                className="form-control"
                                id="remark"
                                name="remark"
                                value={editData?.remark}
                                onChange={handleChange}
                                placeholder="Remark"
                                autoComplete="off"
                                required
                            />
                        </div>


                        <div className="col-md-12">
                            <button
                                type="submit"
                                className="btn btn-ff9b44 btn-block btn-round"
                                onClick={handleClick}
                            >
                                {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Submit"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ComplainUserAppEdit;
